<template>
    <div class="mt-2">
        <div class="d-flex justify-content-center">
            <h5>Tablero de control de listas de chequeo de supervisión</h5>
        </div>
        <b-row class="my-3">
            <b-col>
                <label for="period">Periodo</label>
                <input
                    type="month"
                    id="period"
                    name="monthYear"
                    v-model="period"
                />
            </b-col>
        </b-row>
        <div class="indicators my-5">
            <b-row class="d-flex flex-row">
                <b-col cols="12" md="4" class="d-flex">
                    <!-- <app-average-lists-by-client
                        :series="[
                            (
                                (parseFloat(averageVisitsByClient) / 30) *
                                100
                            ).toFixed(2),
                        ]"
                        :label="`${averageVisitsByClient.toFixed(
                            2
                        )} / 30 Visitas por cliente`"
                    ></app-average-lists-by-client> -->
                    <b-card
                        :title="`${averageVisitsByClient.toFixed(
                            2
                        )} / 30 Visitas por cliente`"
                        class="text-center mb-2 w-100"
                    >
                        <h1>
                            {{
                                (
                                    (parseFloat(averageVisitsByClient) / 30) *
                                    100
                                ).toFixed(2)
                            }}%
                        </h1>
                    </b-card>
                </b-col>
                <b-col cols="12" md="4" class="d-flex">
                    <b-card
                        title="Promedio de visitas por supervisor"
                        class="text-center mb-2 w-100"
                    >
                        <h1>{{ checklistsIndicator.toFixed(2) }}</h1>
                    </b-card>
                </b-col>
                <b-col cols="12" md="4" class="d-flex">
                    <b-card
                        title="Clientes promedio por supervisor"
                        class="text-center mb-2 w-100"
                    >
                        <h1>{{ clientsIndicator.toFixed(2) }}</h1>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <b-tabs v-model="tabIndex">
            <b-tab title="Cumplimiento por cliente">
                <div class="supervision-checklist-compliance">
                    <app-supervision-checklist-compliance
                        :year="year"
                        :month="month"
                        ref="supervisionChecklistCompliance"
                        @loaded="onComplianceLoaded"
                    ></app-supervision-checklist-compliance>
                </div>
            </b-tab>
            <b-tab title="Chequeos por supervisor">
                <div class="supervision-checklist-by-supervisor">
                    <app-supervision-checklist-by-supervisor-chart
                        :year="year"
                        :month="month"
                        ref="supervisionChecklistBySupervisor"
                        @loaded="onChecklistsLoaded"
                    ></app-supervision-checklist-by-supervisor-chart>
                </div>
            </b-tab>
            <b-tab title="Indicadores por sede">
                <app-checklist-items-by-venue-indicators
                    :year="year"
                    :month="month"
                    ref="checklistItemsByVenueIndicators"
                    @show-venue="onShowVenue"
                ></app-checklist-items-by-venue-indicators>
            </b-tab>
            <b-tab title="Indicadores por items">
                <app-checklist-items-indicators
                    :year="year"
                    :month="month"
                    ref="checklistItemsIndicators"
                    :venue-id="venueId"
                ></app-checklist-items-indicators>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import appSupervisionChecklistCompliance from './SupervisionChecklistComplianceChart.vue'
import appSupervisionChecklistBySupervisorChart from './SupervisionChecklistBySupervisorChart.vue'
import appAverageListsByClient from './AverageListsByClient.vue'
import appChecklistItemsIndicators from './ChecklistItemsIndicators.vue'
import appChecklistItemsByVenueIndicators from './ChecklistItemsByVenueIndicators.vue'
export default {
    components: {
        appSupervisionChecklistCompliance,
        appSupervisionChecklistBySupervisorChart,
        appAverageListsByClient,
        appChecklistItemsIndicators,
        appChecklistItemsByVenueIndicators,
    },
    props: {
        //
    },
    data: () => ({
        period: '',
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        complianceData: [],
        checklistsData: [],
        tabIndex: 0,
        venueId: null,
    }),
    watch: {
        period: function (val) {
            const [year, month] = val.split('-')
            this.year = year
            this.month = month
            this.$nextTick(() => {
                this.$refs.supervisionChecklistCompliance.fetchData()
                this.$refs.supervisionChecklistBySupervisor.fetchData()
            })
        },
    },
    computed: {
        averageVisitsByClient() {
            if (this.complianceData.length === 0) return 0

            const sum = this.complianceData.reduce(
                (acc, item) => acc + parseInt(item.visit_days),
                0
            )

            const size = this.complianceData.length

            return sum / size
        },
        checklistsIndicator() {
            if (this.checklistsData.length === 0) return 0

            const totalChecklists = this.checklistsData.reduce(
                (acc, item) => acc + item.checklists,
                0
            )

            const totalSupervisors = this.checklistsData.length

            return totalChecklists / totalSupervisors
        },
        clientsIndicator() {
            if (this.checklistsData.length === 0) return 0

            const totalClients = this.checklistsData.reduce(
                (acc, item) => acc + parseFloat(item.clients),
                0
            )

            const totalSupervisors = this.checklistsData.length

            return totalClients / totalSupervisors
        },
    },
    methods: {
        getCurrentYearMonth() {
            const now = new Date()
            const year = now.getFullYear()
            const month = (now.getMonth() + 1).toString().padStart(2, '0')
            return `${year}-${month}`
        },
        onComplianceLoaded(data) {
            this.complianceData = data
        },
        onChecklistsLoaded(data) {
            this.checklistsData = data
        },
        onShowVenue(indicator) {
            console.log('Showing venue', indicator)
            this.venueId = indicator.venue_id
            this.tabIndex = 3
        },
    },
    mounted() {
        this.period = this.getCurrentYearMonth()
    },
}
</script>
